import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'swiper/css';
import 'swiper/css/autoplay';
import './styles/variables.css';
import './styles/global.css';
import '../public/css/custom.css';
import '../public/css/bootstrap.min.css';
import '../public/css/all.min.css';
import '../public/css/animate.css';
import './styles/sections.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
